export default function(data) {
  return {
    exception: data.exception,
  }
}
